import { useEffect, useRef } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useMe } from "../hooks/useMe";
import { getStoredAuthTokens, getUser } from "../utils/auth";
import { canManageBlogPosts } from "../utils/blogPermissions";

export default function RequireBlogAdmin() {
  const { isLoading, me, refetch } = useMe();
  const location = useLocation();
  const retryingRef = useRef(false);
  const storedUser = getUser();
  const { accessToken, refreshToken } = getStoredAuthTokens();
  const hasAuthToken = Boolean(accessToken || refreshToken);
  const user = me || storedUser;

  const shouldRetryMe = !isLoading && !me && hasAuthToken;
  useEffect(() => {
    if (shouldRetryMe && !retryingRef.current) {
      retryingRef.current = true;
      refetch();
    }
  }, [refetch, shouldRetryMe]);

  useEffect(() => {
    if (me) retryingRef.current = false;
  }, [me]);

  if (isLoading) return null;

  if (!user) {
    if (!hasAuthToken) {
      return <Navigate to="/login" replace state={{ from: location.pathname }} />;
    }
    return null;
  }

  if (!canManageBlogPosts(user)) {
    return <Navigate to="/blog/" replace />;
  }

  return <Outlet />;
}
